import React, { ComponentType } from 'react';

import { ILinkWidgetFragment } from 'generated/sanity-graphql';
import { routes } from 'utils/routing';

import { isExternalLink } from '../is-external-link';

import { ExternalLink as DefaultExternalLink, InternalLink as DefaultInternalLink } from './styled';

type ILinksProps = {
  links: ILinkWidgetFragment[];
  InternalLink?: typeof DefaultInternalLink;
  ExternalLink?: typeof DefaultExternalLink;
};

export const Links: React.FC<ILinksProps> = ({
  links,
  InternalLink = DefaultInternalLink,
  ExternalLink = DefaultExternalLink
}) => {
  return (
    <>
      {links.map((widget, index) => {
        const isExternal = isExternalLink(widget?.link?.locale);

        const Link: ComponentType = isExternal ? ExternalLink : InternalLink;

        const linkProps = {
          ...(isExternal
            ? { href: widget?.link?.locale ?? undefined }
            : { to: widget?.link?.locale ?? routes.base }),
          children: widget?.text?.locale
        };

        return <Link key={widget?._key ?? index} {...linkProps} />;
      })}
    </>
  );
};
